import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class CurrentUserService extends Service {
    constructor() {
        super();
        this.baseURL = 'security/user';
    }

    async getCurrentMerchantUser() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/merchant/currentUser" , {
            headers: {'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"), 'Content-Type': 'application/json'},
        }).then(response => response.json()).catch(error => {
            //GeneralUtils.notification(error);
        });
    }

    async getCurrentAdminOrMemberUser() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/currentUser" , {
            headers: {'Content-Type': 'application/json'},
        }).then(response => response.json()).catch(error => {
            //GeneralUtils.notification(error);
        });
    }


}